// src/actions/engineVersionSkew.js
// Tell "the engine is older than this dashboard" apart from a real failure.
//
// THE TWO ARE NEVER IN LOCKSTEP. This repo auto-deploys on a main merge; the commerce
// engine needs a manual `gcloud builds submit`. So after every release there is a window
// where the dashboard is ahead — and GraphQL rejects the WHOLE query on an unknown
// field, so one new field in a shared selection takes down every page that uses it.
//
// Deliberately dependency-free. It lived in taxonomy_actions.js first, which imports
// axios, which made it untestable under jest ("Cannot use import statement outside a
// module") — and a classifier that decides what an operator is told should not be
// reachable only through the network layer anyway.
export const REQUIRED_ENGINE = "v51";

export function classifyFailure(e) {
  const message = String((e && e.message) || "");
  // GraphQL's own validation wording. Matching the message is unlovely but it is the only
  // signal available: a validation error carries no code, and the alternative is probing
  // the schema on every failure.
  if (/Cannot query field/.test(message)) {
    return {
      ok: false,
      unsupported: true,
      message: `This engine does not have categories or collections yet — it needs ${REQUIRED_ENGINE}.`,
    };
  }
  return { ok: false, message };
}
